"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1732],{

/***/ 11732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _csc_dls_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97638);
/* harmony import */ var _csc_dls_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45468);
/* harmony import */ var _csc_dls_IconRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99821);
/* harmony import */ var _csc_dls_Icons_Play__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14276);
/* harmony import */ var _csc_dls_Icons_Pause__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86058);
/* harmony import */ var _CountdownTimer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27419);








var CountdownTimer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27419)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27419)
            ];
        }
    }
});
var BannerV1 = function(param) {
    var messaging = param.messaging, callToActionUrl = param.callToActionUrl, countdownTarget = param.countdownTarget, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? false : _isScrolling, _scrollable = param.scrollable, scrollable = _scrollable === void 0 ? false : _scrollable, _onTogglePlayPause = param.onTogglePlayPause, onTogglePlayPause = _onTogglePlayPause === void 0 ? function() {} : _onTogglePlayPause, _onSelectTile = param.onSelectTile, onSelectTile = _onSelectTile === void 0 ? function() {} : _onSelectTile, _tilesLenght = param.tilesLenght, tilesLenght = _tilesLenght === void 0 ? 0 : _tilesLenght, selectedIndex = param.selectedIndex;
    var hasValidCountDown = !!countdownTarget && (0,_CountdownTimer__WEBPACK_IMPORTED_MODULE_7__.isValidCountDownDate)(countdownTarget);
    var shouldShowSlide = scrollable && tilesLenght > 1 && !hasValidCountDown;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "banner-header",
        className: "bg-banner px-4 h-14 md:h-12 flex flex-col md:flex-row text-center text-white w-full items-center justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-testid": "sitewide-banner-content",
                className: "justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full ".concat(countdownTarget ? "mr-8" : ""),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                href: callToActionUrl,
                                className: "w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    size: "md",
                                    textTag: "span",
                                    className: "text-white text-center w-full",
                                    children: messaging
                                })
                            })
                        }),
                        hasValidCountDown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountdownTimer, {
                            countdownTargetString: countdownTarget
                        })
                    ]
                })
            }),
            !shouldShowSlide ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:ml-8 mt-2 md:mt-0 flex items-center justify-center",
                children: [
                    Array.from(Array(tilesLenght).keys()).map(function(z, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            "aria-label": "Select Banner ".concat(index),
                            onClick: function() {
                                return onSelectTile(index);
                            },
                            className: "w-2 h-2 rounded ".concat(index === selectedIndex ? "bg-white" : "", " ").concat(index < tilesLenght - 1 ? "mr-1" : "", " border border-white inline-block")
                        }, "tile-".concat(z));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "ml-2",
                        "aria-label": isScrolling ? "pause banner scrolling" : "play banner scrolling",
                        onClick: onTogglePlayPause,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_IconRenderer__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            size: "xxs",
                            IconComponent: isScrolling ? _csc_dls_Icons_Play__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP : _csc_dls_Icons_Pause__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BannerV1);


/***/ }),

/***/ 99821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
exports.IconRenderer = IconRenderer;
exports["default"] = IconRenderer; //# sourceMappingURL=IconRenderer.js.map


/***/ }),

/***/ 86058:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgPause = function SvgPause(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M6.3218 6.58035e-05H4.39005C4.29166 6.58035e-05 4.21185 0.0831389 4.21185 0.18541V7.81466C4.21185 7.91699 4.29172 8 4.39005 8H6.3218C6.42019 8 6.5 7.91693 6.5 7.81466V0.18541C6.5 0.082942 6.42019 4.76837e-07 6.3218 4.76837e-07V6.58035e-05ZM2.60995 6.58035e-05H0.678201C0.579806 6.58035e-05 0.5 0.0831389 0.5 0.18541V7.81466C0.5 7.91699 0.579872 8 0.678201 8H2.60995C2.70834 8 2.78815 7.91693 2.78815 7.81466V0.18541C2.78815 0.082942 2.70828 4.76837e-07 2.60995 4.76837e-07V6.58035e-05Z"
    }));
};
__webpack_unused_export__ = SvgPause;
exports.ZP = SvgPause; //# sourceMappingURL=Pause.js.map


/***/ }),

/***/ 14276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgPlay = function SvgPlay(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "7",
        height: "8",
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React__namespace.createElement("path", {
        d: "M6.23064 4.53592L1.45775 7.89086C1.05072 8.17745 0.5 7.86558 0.5 7.35137V0.649919C0.5 0.127305 1.05073 -0.176157 1.45775 0.110431L6.23064 3.46537C6.58979 3.70986 6.58979 4.28303 6.23064 4.53593V4.53592Z"
    }));
};
__webpack_unused_export__ = SvgPlay;
exports.ZP = SvgPlay; //# sourceMappingURL=Play.js.map


/***/ }),

/***/ 97638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var Link = function Link(_a) {
    var href = _a.href, _b = _a.target, target = _b === void 0 ? "_self" : _b, _c = _a.underline, underline = _c === void 0 ? true : _c, _onClick = _a.onClick, _d = _a.className, className = _d === void 0 ? "" : _d;
    _a.iconColor;
    _a.rightSideIcon;
    var children = _a.children, rest = __rest(_a, [
        "href",
        "target",
        "underline",
        "onClick",
        "className",
        "iconColor",
        "rightSideIcon",
        "children"
    ]);
    return /*#__PURE__*/ React__default["default"].createElement("a", _extends({
        className: "".concat(!!className ? className : "", " ").concat(underline ? "underline" : "no-underline", " cursor-pointer hover:text-accent-2"),
        href: href,
        target: target,
        onClick: function onClick(e) {
            var _$_a, _b;
            _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
            if (target === "_blank") {
                // TODO: define a better way to avoid iframe target _blank restriction
                try {
                    if (window.self !== window.top) {
                        // Inside Iframe
                        (_$_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _$_a === void 0 ? void 0 : _$_a.call(e);
                        window.open(href);
                    }
                } catch (_c) {
                    //  Fail to access window may be due to frame constrains
                    try {
                        (_b = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _b === void 0 ? void 0 : _b.call(e);
                        window.open(href);
                    } catch (error) {
                        console.error("Failed to trigger iframe link target _blank\n".concat(error));
                    }
                }
            }
        }
    }, rest), children);
};
__webpack_unused_export__ = Link;
exports.ZP = Link; //# sourceMappingURL=Link.js.map


/***/ })

}]);